import ServiceApi from "../serviceApi";
/** Сервис для управление интеграцией Telegram */
export default class ServiceIntegrationTelegram {
    /**
     * Маршруты для запросов
     * @private
     * @static
     * @type {Object}
     * @property {String} tgNotifyList
     * @property {String} tgNotifyCreate
     */
    static _requestRouts = {
        tgAccountList: '/tg-notify/list',
        tgAccountCreate: '/tg-notify/create',
        tgAccountUpdate: '/tg-notify/update',
        tgAccountDelete: '/tg-notify/delete'
    };

    static async getTgAccountList(actionAfter = () => {}) {
        try {
            const response = await ServiceApi.get(this._requestRouts.tgAccountList);
            const {data:  accountList = [] } = response;
            actionAfter(this._tgAccountListAfter(accountList));
        } catch(error) {
            console.log(error);
        }
    }

    static async updateTgAccount(body, actionAfter = () => {}, actionError = () => {}) {
        try {
            await ServiceApi.put(
                this._requestRouts.tgAccountUpdate,
                this._tgAccountBefore(body)
            );
            actionAfter()
        } catch(error) {
            console.log(error);
            actionError(error);
        }
    }

    static async deleteTgAccount(accountId, actionAfter = () => {}, actionError = () => {}) {
        try {
            await ServiceApi.delete(this._requestRouts.tgAccountDelete + `/${accountId}`);
            actionAfter();
        } catch(error) {
            console.log(error);
            actionError(error);
        }
    }

    static async createTgAccount(body, actionAfter = () => {}, actionError = () => {}) {
        try {
            const response = await ServiceApi.post(
                this._requestRouts.tgAccountCreate,
                this._tgAccountBefore(body)
            );
            const {data:  account = {} } = response;
            actionAfter(this._tgAccountAfter(account));
        } catch(error) {
            console.log(error);
            actionError(error);
        }
    }

    static _tgAccountBefore(body) {
        const {apiKey = null, secretKey = null, comment = null, id = null} = body;
        return {
            api_key: apiKey,
            secret_key: secretKey,
            comment,
            account_id: id
        };
    }

    static _tgAccountListAfter(items) {
        return items.map(ServiceIntegrationTelegram._tgAccountAfter);
    }

    static _tgAccountAfter(item) {
        const {id = null, api_key: apiKey = null, secret_key: secretKey = null, comment = null} = item;
        return {id, apiKey, secretKey, comment};
    }

}
